module.exports = __webpack_public_path__ + "img/media-english.36db70ab.jpg";